import { render, staticRenderFns } from "./IconTelegram.vue?vue&type=template&id=d5e48d44"
import script from "./IconTelegram.vue?vue&type=script&lang=js"
export * from "./IconTelegram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports